/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useMemo, useState } from 'react'
import block from 'bem-cn'
import { Autoplay, Pagination } from 'swiper'
import { Swiper, SwiperClass, SwiperProps, SwiperSlide } from 'swiper/react'

import './Slider.scss'

import 'swiper/css'
import 'swiper/css/pagination'

interface ISlider extends SwiperProps {
  items: React.ReactNode[]
  isWithPagination?: boolean
  autoplay?: boolean
  infinite?: boolean
  needMobilePagination?: boolean
}

const b = block('slider')

export const Slider: React.FC<ISlider> = ({
  items,
  isWithPagination = true,
  autoplay,
  infinite,
  spaceBetween = 0,
  needMobilePagination = false,
  slidesPerView = 'auto',
  initialSlide,
}) => {
  const [swiperRef, setSwiperRef] = useState<SwiperClass>()

  const properties: SwiperProps = useMemo(
    () => ({
      loop: (infinite !== undefined && infinite) || items.length > 1,
      speed: 1000,
      autoplay:
        (autoplay !== undefined && autoplay) || items.length > 1
          ? {
              delay: 5000,
              disableOnInteraction: false,
              waitForTransition: true,
            }
          : false,
      pagination: isWithPagination && items.length > 1,
      slidesPerView,
      centeredSlides: true,
      initialSlide,
    }),
    [infinite, items.length, autoplay, isWithPagination, slidesPerView, initialSlide],
  )

  const pagination = useMemo(
    () => ({
      clickable: true,
    }),
    [],
  )

  const slidesList = useMemo(() => items.map((item, index) => <SwiperSlide key={index}>{item}</SwiperSlide>), [items])

  useEffect(() => {
    if (swiperRef && properties.autoplay) {
      swiperRef?.autoplay.start()
    }
  }, [properties.autoplay, swiperRef])

  return (
    <div className={b({ needMobilePagination })}>
      <Swiper
        onSwiper={setSwiperRef}
        {...properties}
        className="mySwiper"
        modules={[Autoplay, Pagination]}
        pagination={isWithPagination && pagination}
        slidesPerView={slidesPerView}
        spaceBetween={spaceBetween}
        style={{ direction: 'ltr' }}>
        {slidesList}
      </Swiper>
    </div>
  )
}
